import React, { useState } from 'react';
import {
  Dialog, DialogContent, Typography, Button, Link,
} from '@mui/material';
import Logo from '../../images/logo1.png';

function DialogPropertyOrUserExists(props) {
  const [open, setOpen] = useState(true);

  return (
    <Dialog open={open}>
      <DialogContent style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', height: '400px',
      }}
      >
        <img src={Logo} alt="Logo" style={{ width: '150px' }} />
        {
                    props.message !== ''
                      ? <Typography variant="h5" component="span" style={{ fontWeight: 'bold' }}>{props.message}</Typography>
                      : (
                        <Typography variant="h6" component="span">
                          Você indicou que é um cliente novo, mas já existe uma conta com o e-mail
                          {' '}
                          {props.email}
                          . Se já tem conta em algum na Greenfy,
                          pode usar a mesma conta e senha para fazer o login no
                          <Link href="https://app.crevettic.com" target="_blank" style={{ color: '#f55420', fontWeight: 'bold' }}>app.crevettic.com</Link>
                        </Typography>
                      )
                }

        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          style={{ backgroundColor: '#f55420', color: '#fff' }}
        >
          Ok
        </Button>
      </DialogContent>
    </Dialog>
  );
}

export default DialogPropertyOrUserExists;
